// extracted by mini-css-extract-plugin
module.exports = {"Form":"Auth_Form__1Tklh","Btn":"Auth_Btn__1ZyE6","Error":"Auth_Error__BkJd8","ContactData":"Auth_ContactData__24hjm"};